<template>
  <div id="icommunityApp" class="c-content">
    <banner-general :content="banner"></banner-general>

    <div class="c-content__imageBlock c-standard">
      <div class="c-content__imageBlock--text" style="width: calc(100% - 280px); min-height: auto; height: auto;">
        <p>{{ imgBlock.content }}</p>
      </div>
      <div class="c-content__imageBlock--image" style="width: 280px; text-align: center; min-height: auto; height: auto;">
        <img :src="imgBlock.img" alt="qr" style="height: auto; width: 40%">
        <p style="font-size: 13px;margin-top:5px">{{ imgBlock.downloadTxt }}</p>
      </div>
    </div>
    <div class="c-contact" :style="{backgroundImage:'url('+ picBlock.bgImage +')'}">
      <div class="c-standard c-contact__imgBlock">
        <div v-for="(item, index) in picBlock.items" :key="index">
          <img :src="item.img" :alt="index">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'
  import BannerGeneral from '../layout/bannerGeneral.vue'

  export default {
    name: 'icommunityApp',
    components: {
      'banner-general': BannerGeneral,
    },
    data(){
      return {
        icommunity: {
          more: this.$t('common.more'),
          goBack: this.$t('menu.community_back'),
        },
        banner: {
          type: '1',
          img: require('../../assets/img/banner_download.jpg'),
          noShadow: 0,
        },
        languageDefault: localStorage.getItem('lang') || 'zh_cn',

        imgBlock:{
          content: '爱康居通过利用IOT技术、移动互联网、云计算、人工智能等信息技术，形成 “智能硬件+平台+运营“ 的服务模式，提升社区治理和管理水平，完善社区公共服务和便民利民的智能化服务，打造安全、便利、高品质的智慧生活服务。用户有任何需要可以在手机app上在线解决，不出门也可解决生活所需；还能为用户实时发布社区公告和新闻，方便用户知晓社区情况，为广大用户提供便捷的生活；同时为用户提供维修服务，能够及时上报信息，物业快速维修，解决燃眉之急；更有周边商圈、智能门禁、智能家居、场馆活动预订、便民信息、社区论坛、访客邀请、在线缴费等强大功能。',
          downloadTxt: '扫描二维码下载应用',
          img: require('../../assets/img/download_qr.png'),
        },
        picBlock: {
          bgImage: require('../../assets/img/bg_download_app.png'),
          items: [
            { img: require('../../assets/img/pic_app01.png') },
            { img: require('../../assets/img/pic_app02.png') },
            { img: require('../../assets/img/pic_app03.png') },
            { img: require('../../assets/img/pic_app04.png') },
          ],
        }
      }
    },
    computed: {

    },
    created () {

    },
    methods: {

    },
  }
</script>
